import { useEffect } from "react";
import { Navigate } from "react-router";
import { StartMlsSubscriptionForm } from "./StartMlsSubscriptionForm";
import { StartIndividualSubscription } from "./starters/StartIndividualSubscription";
import { SubscriptionContainer } from "../components/styles";
import { useDomainGroup } from "@shared/hooks/useDomainGroup";
import { useOtherDomainGroupUrl } from "@shared/hooks/useOtherDomainGroupUrl";
import { DomainGroup, domainGroupEnum } from "@shared/utils/domain-group";
import { BrandSwitchPrompt } from "@shared/components/BrandSwitchPrompt";
import { INDIVIDUAL_PLAN, INDIVIDUAL_PLAN_ID } from "../individual-plan";

const SIGNUP_ENTRY_PATH: Record<DomainGroup, string> = {
  [domainGroupEnum.SIDEKICK]: "/subscribe/mls",
  [domainGroupEnum.RADAR]: `/subscribe/partner/${INDIVIDUAL_PLAN_ID}`,
};

type Props = {
  defaultValues: {
    partnerId?: string;
  };
  showMlsPicker: boolean;
};

export const StartSubscriptionFlow = (props: Props) => {
  const { defaultValues, showMlsPicker } = props;
  const domainGroup = useDomainGroup();
  const otherDomainIndividualUrl = useOtherDomainGroupUrl(
    `/subscribe/partner/${INDIVIDUAL_PLAN_ID}`,
  );

  // The individual plan only belongs to Radar - a Sidekick visitor landing
  // here directly (e.g. an old bookmark) is sent to the same URL on Radar's
  // own domain, rather than Sidekick's unrelated MLS signup flow.
  const isWrongBrandIndividualLink =
    defaultValues.partnerId === INDIVIDUAL_PLAN_ID &&
    domainGroup !== domainGroupEnum.RADAR;

  useEffect(() => {
    if (isWrongBrandIndividualLink) {
      window.location.replace(otherDomainIndividualUrl);
    }
  }, [isWrongBrandIndividualLink, otherDomainIndividualUrl]);

  if (isWrongBrandIndividualLink) {
    return null;
  }

  if (defaultValues.partnerId === INDIVIDUAL_PLAN_ID) {
    return (
      <SubscriptionContainer>
        <StartIndividualSubscription
          planId={INDIVIDUAL_PLAN.id}
          planName={INDIVIDUAL_PLAN.name}
        />
        <BrandSwitchPrompt actionLabel="Sign up here" path="/subscribe" />
      </SubscriptionContainer>
    );
  }

  if (!defaultValues.partnerId && !showMlsPicker) {
    return <Navigate to={SIGNUP_ENTRY_PATH[domainGroup]} replace />;
  }

  return (
    <SubscriptionContainer>
      <StartMlsSubscriptionForm defaultValues={defaultValues} />
      <BrandSwitchPrompt actionLabel="Sign up here" path="/subscribe" />
    </SubscriptionContainer>
  );
};
